"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ClockForward16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "clock-forward-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M10,6 L10,4 L12.4723307,4.0001315 C11.3736859,2.77255645 9.77706308,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C10.8116315,14 13.1715688,12.0660675 13.8221551,9.4558592 L15.7628735,9.9411456 C14.895425,13.4214233 11.7488419,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C10.3900817,0 12.5353617,1.04812066 14.001282,2.70980401 L14,0 L16,0 L16,6 L10,6 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" }),
            react_1.default.createElement("polygon", { id: "Path-2", fill: "#000000", fillRule: "nonzero", points: "11.4490909 9.55272727 10.3690909 10.9927273 7 8.54090909 7 3 9 3 9 7.64090909" })));
}
function ClockForward16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ClockForward16Svg, Object.assign({}, svgProps)));
}
exports.default = ClockForward16;
//# sourceMappingURL=ClockForward16.js.map